const PressVue = () => {

    const sections = document.getElementsByClassName( "multipress" )

    if ( sections.length > 0 ) {
        for ( var i = 0; i < sections.length; i ++ ) {

            new Vue( {
                el: '#' + sections[ i ].id,
                data() {
                    return {
                        taxonomy : '',
                        press : [],
                        endpoint: '',
                        // basic_username: false,
                        // basic_pwd: false,
                        page: 1,
			            perPage: 20,
				        pages: [],	
				        totalePress : '',
                        press_year: '',
                        press_newspaper: '',
                        press_structure: '',
                        years: [],
                        news_papers: [],
                        loading: true,
                    }
                },
                mounted: function () {

                    this.taxonomy = this.$el.attributes.taxonomy.value;

                    const PRESS_URL = document.getElementById('press_url_'+this.taxonomy).value;
                    const PRESS_MONDO = document.getElementById('press_mondo_'+this.taxonomy).value;
                    const PRESS_TERM_SLUG = document.getElementById('press_term_slug_'+this.taxonomy).value;

                    // if ( document.getElementById('basic_username_'+this.taxonomy) ) {
                    //     this.basic_username = document.getElementById('basic_username_'+this.taxonomy).value;
                    // }

                    // if ( document.getElementById('basic_pwd_'+this.taxonomy) ) {
                    //     this.basic_pwd = document.getElementById('basic_pwd_'+this.taxonomy).value;
                    // }

                    let endpoint_press = `${PRESS_URL}/wp-json/api/v1/stampa`;


                    if ( PRESS_MONDO && PRESS_MONDO != 'corporate') {
                        endpoint_press += '?mondo='+PRESS_MONDO;
                        if ( PRESS_TERM_SLUG ) {
                            endpoint_press += '&term_slug='+PRESS_TERM_SLUG;
                        }
                    }else if ( PRESS_TERM_SLUG ) {
                        endpoint_press += '?term_slug='+PRESS_TERM_SLUG;
                    }

                    this.endpoint = endpoint_press;

                    this.getPress();
                    let vm = this;

                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    if(urlParams.get('strtid')){
                        let str = urlParams.get('strtid');
                        this.press_structure = str; 
                        jQuery(this.$refs.press_structure).select2().val(str).trigger("change")                       
                    }

                    if ( this.$refs.press_year ) {
                        jQuery(this.$refs.press_year).select2({
                            theme: "bootstrap-5",
                            dropdownParent: jQuery(this.$refs.press_year).parent(),
                            templateResult: this.formatSearchResult,
                            //data: this.years,
                            placeholder: 'Anno',
                            allowClear: true,
                        })
                        .on('change', (e) => {
                            this.press_year = e.target.value;
                        });
                    }

                    if ( this.$refs.press_structure ) {
                        jQuery(this.$refs.press_structure).select2({
                            theme: "bootstrap-5",
                            dropdownParent: jQuery(this.$refs.press_structure).parent(),
                            templateResult: this.formatSearchResult,
                            placeholder: 'Struttura',
                            allowClear: true,
                        }).on('change', (e) => {
                            this.press_structure = e.target.value;
                        });
                    }

                    if ( this.$refs.press_newspaper ) {
                        jQuery(this.$refs.press_newspaper).select2({
                            theme: "bootstrap-5",
                            dropdownParent: jQuery(this.$refs.press_newspaper).parent(),
                            templateResult: this.formatSearchResult,
                            placeholder: 'Testata',
                            allowClear: true,
                        }).on('change', (e) => {
                            this.press_newspaper = e.target.value;
                        });
                    }

                },
                methods: {
                    getPress() {

                        fetch( this.endpoint )
                        .then(res => res.json())
                        .then(data => {
                            this.press = data.press;
                            this.years = data.years;
                            this.news_papers = data.news_papers;
                            this.loading = false;
                        });
                    
                    },
                    formatSearchResult(result) {
                        if (!result.id) {
                            return result.text;
                        }
                    
                        var query = jQuery('.select2-search__field').val();
                        var str = result.text;
                    
                        var regex = new RegExp(query, 'i');
                        var indexQuery = (str.toLowerCase()).indexOf(query.toLowerCase());
                    
                        var highlightText = str.substring(indexQuery, indexQuery + query.length);
                        var newStr = str.replace(regex, '<span style="font-weight:bold">' + highlightText + '</span>')
                    
                        return jQuery('<span>' + newStr + '</span>');
                    },
                    markMatch(text, term) {
                        var regEx = new RegExp("(" + term + ")(?!([^<]+)?>)", "gi");
                        var output = text.replace(regEx, "<span class='select2-rendered__match'>$1</span>");
                        return output;
                    },

                    paginate (posts) {
                        let page = this.page;
                        let perPage = this.perPage;
                        let from = (page * perPage) - perPage;
                        let to = (page * perPage);
                        return  posts.slice(from, to);
                    },
                    setPages() {
                        let numberOfPages = Math.ceil(this.totalePress / this.perPage);
                        this.pages = []; /* svuoto e ri-riempio */
                        for (let index = 1; index <= numberOfPages; index++) {
                            this.pages.push(index);
                        }
                    },
                    resetPressFilters( message, event ) {
    
                        this.press_year = '';
                        this.press_newspaper = '';
                        this.press_structure = '';
                        if ( this.$refs.press_year ) {
                            jQuery(this.$refs.press_year).val('').trigger('change');
                        }
                        if ( this.$refs.press_newspaper ) {
                            jQuery(this.$refs.press_newspaper).val('').trigger('change');
                        }
                        if ( this.$refs.press_structure ) {
                            jQuery(this.$refs.press_structure).val('').trigger('change');
                        }
                        
                        
                        
                    }
                },
                computed: {
                    pressYear(){
                        let anni = [];
                        this.computedPress.forEach((index,item) => {
                            if(!anni.includes( item.year)){
                                anni.push({
                                    id: index,
                                    text: item.year
                                });
                            }
                            
                        });
                        return anni;
                    },
                    pressNewsPaper(){
                        return this.news_papers;
                    },
                    paginatedPress(){
                        this.totalePress = this.computedPress.length;
                        return this.paginate(this.computedPress);
                    },
                    computedPress(){			
                        
                        return this.press.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true

                            (item) => {	
                                let press_year = this.press_year ? (item.year == this.press_year) : true;
                                let press_newspaper = this.press_newspaper ? (item.newspaperid == this.press_newspaper) : true;
                                //let press_structure = this.press_structure ? (item.structureUid.toLowerCase() == this.press_structure.toLowerCase()) : true;
                                let press_structure = this.press_structure ? item.strutture_associate.some(value => value.structureUid.toLowerCase() == this.press_structure.toLowerCase()) : true;
                                return press_year && press_newspaper && press_structure;

                            }
                        ) /* filter */

                    }
                },
                watch: { 
                    totalePress() {
                        this.setPages(); /* ogni volta che totaleMedici cambia esegi setPages */
                    }
                },
            });
        }
    }
}


export default PressVue;
